// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/mountainsForst.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   ABOUT — Team + FAQ blocks (appended below Why Forge Exists)
   ============================================================ */

.about-team,
.about-faq-wrap {
  padding-top: clamp(2.5rem, 5vw, 4rem);
}

/* ── Eyebrow + rule row (shared pattern) ── */
.about-team__eyebrow-row {
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  margin-bottom: var(--sp-5);
}
.about-team__eyebrow {
  color: var(--accent);
  white-space: nowrap;
}
.about-team__rule {
  flex: 1 1;
  height: 1px;
  background: var(--line);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: start;
  color: var(--text-muted);
}
.about-team__rule svg {
  background: var(--bg);
  padding: 0 var(--sp-1);
  /* font-size: 1.1rem; */
}

/* ── Team grid ── */
.about-team__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-5);
}
@media (max-width: 991.98px) {
  .about-team__grid {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 640px) {
  .about-team__grid {
    grid-template-columns: 1fr;
  }
}

.about-team__card {
  position: relative;
  background: var(--c-cream);
  border-left: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-radius: 12px;
  padding: var(--sp-6);
  min-height: 320px;
  overflow: hidden;
}

.about-team__photo {
  width: 100%;
  height: 400px;
  border-radius: 2%;
  object-fit: cover;
  object-position: 0% 30%;
  margin-bottom: var(--sp-3);
}

/* .about-team__photo {
  width: 180px;
  height: 180px;
  border-radius: 100%;
  object-fit: cover;
  object-position: top;
  margin-bottom: var(--sp-3);
} */

.about-team__role {
  display: block;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
  color: var(--c-ink);
}

.about-team__name {
  font-family: var(--font-serif);
  font-size: clamp(1.6rem, 2.5vw, 2.1rem);
  color: var(--c-forest);
  font-style: italic;
  margin: 4px 0 var(--sp-2);
}

.about-team__dash {
  display: block;
  width: 36px;
  height: 3px;
  background: var(--accent);
  margin-bottom: var(--sp-3);
}

.about-team__bio {
  font-size: var(--fs-sm);
  color: var(--text-ink);
  line-height: var(--lh-body);
  max-width: 50ch;
}

.about-team__stamp {
  position: absolute;
  right: var(--sp-2);
  bottom: var(--sp-4);
  opacity: 0.7;
  transform: scale(0.8);
  transform-origin: left bottom;
  pointer-events: none;
}

/* ── Pending card — sage/forest tinted with tree silhouette ── */
.about-team__card--pending {
  background:
    linear-gradient(180deg, rgba(95, 113, 88, 0.5) 0%, rgba(56, 70, 56, 0.55) 100%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom / cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--c-sand);
}

.about-team__pending-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid rgba(27, 27, 27, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: var(--c-sand);
  margin-bottom: var(--sp-4);
  background: rgba(255, 255, 255, 0.4);
}

.about-team__pending-label {
  font-family: var(--font-serif);
  font-weight: 700;
  font-size: var(--fs-h3);
  color: var(--c-sand);
  max-width: 20ch;
}

.about-team__pending-sub {
  margin-top: var(--sp-2);
  font-size: var(--fs-sm);
  color: rgba(27, 27, 27, 0.65);
  max-width: 30ch;
}

/* ── FAQ outer wrap ── */
.about-faq {
  background: var(--c-forest);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: var(--sp-6);
}

.about-faq__eyebrow-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-3);
  margin-bottom: var(--sp-5);
}
.about-faq__eyebrow {
  color: var(--accent);
  white-space: nowrap;
  font-family: var(--font-body);
  font-size: var(--fs-md);
}
.about-faq__dots {
  color: var(--c-rust);
  letter-spacing: 4px;
  font-size: var(--fs-lg);
  font-weight: 900;
}

.about-faq__list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.about-faq__item {
  border: 1px solid var(--line);
  border-radius: 10px;
  background: var(--c-sand);
  overflow: hidden;
  transition: border-color 0.25s var(--ease);
}
.about-faq__item--open {
  border-color: var(--accent);
}

.about-faq__q {
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  background: none;
  border: none;
  padding: var(--sp-4) var(--sp-5);
  text-align: left;
  cursor: pointer;
}

.about-faq__q-icon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--c-sand);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  color: var(--c-ink);
  transition:
    background 0.25s var(--ease),
    color 0.25s var(--ease);
}
.about-faq__item--open .about-faq__q-icon {
  background: var(--accent);
  color: #fff;
}

.about-faq__q-text {
  flex: 1 1;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-body);
  color: var(--c-ink);
  transition: color 0.25s var(--ease);
}
.about-faq__item--open .about-faq__q-text {
  color: var(--accent);
}

.about-faq__toggle {
  flex: 0 0 auto;
  font-size: 1.3rem;
  line-height: 1;
  color: var(--text-muted);
}
.about-faq__item--open .about-faq__toggle {
  color: var(--accent);
}

.about-faq__a-wrap {
  overflow: hidden;
}
.about-faq__a {
  padding: 0 var(--sp-5) var(--sp-4) calc(40px + var(--sp-4) + var(--sp-5));
  font-size: var(--fs-sm);
  color: var(--text-muted);
  line-height: var(--lh-body);
}
@media (max-width: 560px) {
  .about-faq__a {
    padding-left: var(--sp-5);
  }
  .about-faq__eyebrow {
    font-size: var(--fs-xs);
  }
}

.about-faq__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 var(--sp-5) var(--sp-4) calc(40px + var(--sp-4) + var(--sp-5));
  font-size: var(--fs-xs);
  font-weight: 700;
  color: var(--accent);
}
.about-faq__link-out {
  font-size: 0.7em;
}
@media (max-width: 560px) {
  .about-faq__link {
    margin-left: var(--sp-5);
  }
}

/* ── Full-width mountain band ── */
.about-mountain-band {
  margin-top: var(--sp-8);
  width: 100%;
  overflow: hidden;
}
.about-mountain-band img {
  width: 30%;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/About.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;;EAEE,qCAAqC;AACvC;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;EAClC,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;;;;;;GAOG;;AAEH;EACE,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,iEAAiE;AACjE;EACE;;oEAE2E;EAC3E,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB;;2BAEyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,yEAAyE;EACzE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wEAAwE;EACxE,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;AAChB","sourcesContent":["/* ============================================================\n   ABOUT — Team + FAQ blocks (appended below Why Forge Exists)\n   ============================================================ */\n\n.about-team,\n.about-faq-wrap {\n  padding-top: clamp(2.5rem, 5vw, 4rem);\n}\n\n/* ── Eyebrow + rule row (shared pattern) ── */\n.about-team__eyebrow-row {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n  margin-bottom: var(--sp-5);\n}\n.about-team__eyebrow {\n  color: var(--accent);\n  white-space: nowrap;\n}\n.about-team__rule {\n  flex: 1;\n  height: 1px;\n  background: var(--line);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  color: var(--text-muted);\n}\n.about-team__rule svg {\n  background: var(--bg);\n  padding: 0 var(--sp-1);\n  /* font-size: 1.1rem; */\n}\n\n/* ── Team grid ── */\n.about-team__grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--sp-5);\n}\n@media (max-width: 991.98px) {\n  .about-team__grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n@media (max-width: 640px) {\n  .about-team__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.about-team__card {\n  position: relative;\n  background: var(--c-cream);\n  border-left: 1px solid var(--line);\n  border-bottom: 1px solid var(--line);\n  border-radius: 12px;\n  padding: var(--sp-6);\n  min-height: 320px;\n  overflow: hidden;\n}\n\n.about-team__photo {\n  width: 100%;\n  height: 400px;\n  border-radius: 2%;\n  object-fit: cover;\n  object-position: 0% 30%;\n  margin-bottom: var(--sp-3);\n}\n\n/* .about-team__photo {\n  width: 180px;\n  height: 180px;\n  border-radius: 100%;\n  object-fit: cover;\n  object-position: top;\n  margin-bottom: var(--sp-3);\n} */\n\n.about-team__role {\n  display: block;\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n  color: var(--c-ink);\n}\n\n.about-team__name {\n  font-family: var(--font-serif);\n  font-size: clamp(1.6rem, 2.5vw, 2.1rem);\n  color: var(--c-forest);\n  font-style: italic;\n  margin: 4px 0 var(--sp-2);\n}\n\n.about-team__dash {\n  display: block;\n  width: 36px;\n  height: 3px;\n  background: var(--accent);\n  margin-bottom: var(--sp-3);\n}\n\n.about-team__bio {\n  font-size: var(--fs-sm);\n  color: var(--text-ink);\n  line-height: var(--lh-body);\n  max-width: 50ch;\n}\n\n.about-team__stamp {\n  position: absolute;\n  right: var(--sp-2);\n  bottom: var(--sp-4);\n  opacity: 0.7;\n  transform: scale(0.8);\n  transform-origin: left bottom;\n  pointer-events: none;\n}\n\n/* ── Pending card — sage/forest tinted with tree silhouette ── */\n.about-team__card--pending {\n  background:\n    linear-gradient(180deg, rgba(95, 113, 88, 0.5) 0%, rgba(56, 70, 56, 0.55) 100%),\n    url(\"../../../public/assets/mountainsForst.png\") no-repeat bottom / cover;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: var(--c-sand);\n}\n\n.about-team__pending-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  border: 1px solid rgba(27, 27, 27, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  color: var(--c-sand);\n  margin-bottom: var(--sp-4);\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.about-team__pending-label {\n  font-family: var(--font-serif);\n  font-weight: 700;\n  font-size: var(--fs-h3);\n  color: var(--c-sand);\n  max-width: 20ch;\n}\n\n.about-team__pending-sub {\n  margin-top: var(--sp-2);\n  font-size: var(--fs-sm);\n  color: rgba(27, 27, 27, 0.65);\n  max-width: 30ch;\n}\n\n/* ── FAQ outer wrap ── */\n.about-faq {\n  background: var(--c-forest);\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: var(--sp-6);\n}\n\n.about-faq__eyebrow-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--sp-3);\n  margin-bottom: var(--sp-5);\n}\n.about-faq__eyebrow {\n  color: var(--accent);\n  white-space: nowrap;\n  font-family: var(--font-body);\n  font-size: var(--fs-md);\n}\n.about-faq__dots {\n  color: var(--c-rust);\n  letter-spacing: 4px;\n  font-size: var(--fs-lg);\n  font-weight: 900;\n}\n\n.about-faq__list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-3);\n}\n\n.about-faq__item {\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  background: var(--c-sand);\n  overflow: hidden;\n  transition: border-color 0.25s var(--ease);\n}\n.about-faq__item--open {\n  border-color: var(--accent);\n}\n\n.about-faq__q {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n  background: none;\n  border: none;\n  padding: var(--sp-4) var(--sp-5);\n  text-align: left;\n  cursor: pointer;\n}\n\n.about-faq__q-icon {\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--c-sand);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  color: var(--c-ink);\n  transition:\n    background 0.25s var(--ease),\n    color 0.25s var(--ease);\n}\n.about-faq__item--open .about-faq__q-icon {\n  background: var(--accent);\n  color: #fff;\n}\n\n.about-faq__q-text {\n  flex: 1;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-body);\n  color: var(--c-ink);\n  transition: color 0.25s var(--ease);\n}\n.about-faq__item--open .about-faq__q-text {\n  color: var(--accent);\n}\n\n.about-faq__toggle {\n  flex: 0 0 auto;\n  font-size: 1.3rem;\n  line-height: 1;\n  color: var(--text-muted);\n}\n.about-faq__item--open .about-faq__toggle {\n  color: var(--accent);\n}\n\n.about-faq__a-wrap {\n  overflow: hidden;\n}\n.about-faq__a {\n  padding: 0 var(--sp-5) var(--sp-4) calc(40px + var(--sp-4) + var(--sp-5));\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n}\n@media (max-width: 560px) {\n  .about-faq__a {\n    padding-left: var(--sp-5);\n  }\n  .about-faq__eyebrow {\n    font-size: var(--fs-xs);\n  }\n}\n\n.about-faq__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 var(--sp-5) var(--sp-4) calc(40px + var(--sp-4) + var(--sp-5));\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  color: var(--accent);\n}\n.about-faq__link-out {\n  font-size: 0.7em;\n}\n@media (max-width: 560px) {\n  .about-faq__link {\n    margin-left: var(--sp-5);\n  }\n}\n\n/* ── Full-width mountain band ── */\n.about-mountain-band {\n  margin-top: var(--sp-8);\n  width: 100%;\n  overflow: hidden;\n}\n.about-mountain-band img {\n  width: 30%;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
